import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import {
    PERMISSION_FEATURE,
    PERMISSION_TYPE,
    PRODUCT_CATEGORY
} from '../../common/constant/page-constant'
import {
    addReminderAlertAction,
    deleteReminderAlertAction
} from '../../modules/actions/action'
import Alert from '../../components/Alert/Alert'
import {
    addReminderHelper,
    deleteReminderHelper,
    getReminderHelper
} from '../../helper/query-helper'
import { formatDate } from '../../common/utils/appUtils'
import CloseIcon from '../../assets/CloseIcon'
import DotsIcon from '../../assets/DotsIcon'
import AddIcon from '../../assets/AddIcon'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import SideDrawer from '../Common/SideDrawer/SideDrawer'

const ReminderSettings = props => {
    const { onBackClick, permissions } = props
    const isMobile = useCheckMobileScreen()
    const [viewDrawer, setViewDrawer] = useState(false)
    const [open, setOpen] = useState(false)
    const [addReminderAlert, setAddReminderAlert] = useState(false)
    const [deleteReminderAlert, setDeleteReminderAlert] = useState(false)
    const [reminderList, setReminderList] = useState([])
    const [title, setTitle] = useState('Soon to be Expired Product')
    const [days, setDays] = useState('')
    const [repeat, setRepeat] = useState(undefined)
    const [productType, setProductType] = useState(PRODUCT_CATEGORY.PHARMACEUTICAL)
    const [isErrorFieldVisible, setIsErrorFieldVisible] = useState(false)
    const [isCardActive, setIsCardActive] = useState(undefined)

    useEffect(() => {
        let addReminderAlert = props.alert?.addReminderAlert
        setAddReminderAlert(addReminderAlert)

        let deleteReminderAlert = props.alert?.deleteReminderAlert
        setDeleteReminderAlert(deleteReminderAlert)
    }, [props.alert?.addReminderAlert, props.alert?.deleteReminderAlert])

    useEffect(() => {
        getReminderData()
    }, [])

    const getReminderData = () => {
        getReminderHelper()
            .then(rData => {
                setReminderList(rData || [])
            })
            .catch(() => {
                setReminderList([])
            })
    }

    const handleDrawerToggle = () => {
        setViewDrawer(!viewDrawer)
        setOpen(!open)
    }

    const handleSubmit = e => {
        e?.preventDefault()

        if (!title || !days || !repeat?.value) {
            setIsErrorFieldVisible(true)
            return
        }

        setIsErrorFieldVisible(false)

        let data = {
            title: title,
            repeat: repeat?.value,
            days: parseInt(days),
            product_type: productType
        }

        addReminderHelper(data)
            .then(() => {
                resetData()

                props.addReminderAlertAction(true)

                setTimeout(() => {
                    props.addReminderAlertAction(false)
                }, 5000)

                getReminderData()
            })
            .catch(() => {
                // Silently handle error - API might not support new fields yet
                console.log('Failed to add reminder')
            })
    }

    const onCardAction = (id, action) => {
        if (action === 'DELETE') {
            deleteReminderHelper(id)
                .then(() => {
                    props.deleteReminderAlertAction(true)

                    setTimeout(() => {
                        props.deleteReminderAlertAction(false)
                    }, 5000)

                    getReminderData()
                })
                .catch(() => {
                    console.log('Failed to delete reminder')
                })
        }
    }

    const resetData = () => {
        setTitle('Soon to be Expired Product')
        setRepeat('')
        setDays('')
        setProductType(PRODUCT_CATEGORY.PHARMACEUTICAL)
    }

    const renderForm = () => (
        <form>
            <div className="panelHeading">Add Reminder</div>
            <div className="formGroup formFloating fgrow1">
                <input
                    type="text"
                    className="formControl"
                    id="reminderTitle"
                    placeholder="Reminder Title"
                    value={title}
                    onChange={e => setTitle(e?.target?.value)}
                    required
                />
                <label htmlFor="reminderTitle">Reminder Title</label>
                {isErrorFieldVisible && !title && (
                    <div className="invalidFeedback">
                        Please enter a valid Reminder Title.
                    </div>
                )}
            </div>

            <div className="formSection dFlex mb-4">
                <div className="formCheck">
                    <input
                        className="formCheckInput"
                        type="radio"
                        name="productType"
                        id="pharmaceutical"
                        checked={productType === PRODUCT_CATEGORY.PHARMACEUTICAL}
                        onChange={() => setProductType(PRODUCT_CATEGORY.PHARMACEUTICAL)}
                    />
                    <label className="formCheckLabel" htmlFor="pharmaceutical">
                        Pharmaceutical
                    </label>
                </div>
                <div className="formCheck">
                    <input
                        className="formCheckInput"
                        type="radio"
                        name="productType"
                        id="nonPharmaceutical"
                        checked={productType === PRODUCT_CATEGORY.NON_PHARMACEUTICAL}
                        onChange={() => setProductType(PRODUCT_CATEGORY.NON_PHARMACEUTICAL)}
                    />
                    <label className="formCheckLabel" htmlFor="nonPharmaceutical">
                        Non-Pharmaceutical
                    </label>
                </div>
            </div>

            <div className="daysInputWrap dFlex aiCenter mb-4">
                <div className="formGroup formFloating mb-0" style={{ maxWidth: '100px' }}>
                    <input
                        type="number"
                        className="formControl"
                        id="days"
                        placeholder="Days"
                        value={days}
                        onChange={e => setDays(e?.target?.value)}
                        min="1"
                        required
                    />
                    <label htmlFor="days">Days</label>
                </div>
                <span className="daysLabel ml-3">Before Expiry Date</span>
            </div>
            {isErrorFieldVisible && !days && (
                <div className="invalidFeedback mb-3">
                    Please enter number of days.
                </div>
            )}

            <div className="formGroup formFloating fgrow1 maxWidth">
                <Select
                    className="formSelect reactSelect"
                    id="floatingSelect"
                    value={repeat}
options={[
                                        { label: 'Does Not Repeat', value: 'DOES_NOT_REPEAT' },
                                        { label: 'Daily', value: 'DAILY' },
                                        { label: 'Weekly', value: 'WEEKLY' },
                                        { label: 'Monthly', value: 'MONTHLY' }
                                    ]}
                    onChange={option => setRepeat(option)}
                    placeholder="Select Repeat"
                    styles={{
                        control: base => ({
                            border: 0,
                            display: 'flex',
                            paddingTop: '20px'
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused
                                ? 'rgb(222, 235, 255)'
                                : state.isSelected
                                ? '#FFF'
                                : 'inherit',
                            color: '#212529',
                            '&:hover': {
                                backgroundColor: state.isSelected
                                    ? '#DEEBFF'
                                    : 'rgb(222, 235, 255)'
                            }
                        })
                    }}
                    getOptionLabel={option => option?.label}
                    getOptionValue={option => option?.value}
                    isClearable
                />
                <label htmlFor="floatingSelect">Repeat</label>
                {isErrorFieldVisible && !repeat && (
                    <div className="invalidFeedback">Please choose Repeat</div>
                )}
            </div>

            <div className="actionRow">
                <button
                    className="btn btnPrimary block"
                    onClick={e => handleSubmit(e)}>
                    Save
                </button>
            </div>
        </form>
    )

    return (
        <>
            {addReminderAlert && (
                <Alert
                    success
                    alertType="success"
                    alertMessage="Reminder added Successfully!"
                />
            )}
            {deleteReminderAlert && (
                <Alert
                    success
                    alertType="success"
                    alertMessage="Reminder deleted Successfully!"
                />
            )}
            
            {isMobile && (
                <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
                    <button
                        className="animated zoomIn btn btnPrimary"
                        onClick={handleDrawerToggle}>
                        <AddIcon />
                    </button>
                </div>
            )}

            <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                <div className="pageBodyRightPanelHeading">Reminder Settings</div>
            </div>

            <div className="pageBodyPanelWrap dFlex">
                <div className="pageBodyLeftPanel">
                    {reminderList?.map(reminder => (
                        <div className="card helpCard" key={reminder?.id}>
                            <div className="cardHeader">
                                <div className="cardHeaderDetails">
                                    <div className="reminderTitle">{reminder?.title}</div>
                                    <div className="reminderCategory">
                                        {reminder?.product_type === PRODUCT_CATEGORY.NON_PHARMACEUTICAL 
                                            ? 'Non-Pharmaceutical' 
                                            : 'Pharmaceutical'}
                                    </div>
                                    <div className="reminderDays">
                                        {reminder?.days} days before expiry
                                    </div>
                                </div>
                                <div className="cardHeaderRight">
                                    {isCardActive === reminder?.id ? (
                                        <span onClick={() => setIsCardActive(undefined)}>
                                            <CloseIcon />
                                        </span>
                                    ) : (
                                        <span onClick={() => setIsCardActive(reminder?.id)}>
                                            <DotsIcon />
                                        </span>
                                    )}
                                    <ul
                                        className={`cardActionsWrapper ${
                                            isCardActive === reminder?.id ? 'show' : 'hide'
                                        }`}>
                                        {['DELETE']?.map(action => (
                                            <li
                                                key={action}
                                                className="actionItem"
                                                onClick={() => {
                                                    setIsCardActive(false)
                                                    onCardAction(reminder?.id, action)
                                                }}>
                                                {action}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="cardFooter">
                                <ul className="helpDuration dFlex">
                                    <li className="duration">
                                        {formatDate(reminder?.created_at)}
                                    </li>
                                    <li className="duration">
                                        Repeat: {reminder?.repeat === 'DOES_NOT_REPEAT' ? 'Does Not Repeat' : reminder?.repeat === 'DAILY' ? 'Daily' : reminder?.repeat === 'WEEKLY' ? 'Weekly' : reminder?.repeat === 'MONTHLY' ? 'Monthly' : reminder?.repeat}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>

                {!isMobile &&
                    permissions?.features?.[PERMISSION_FEATURE.REMINDER_SETTINGS] ===
                        PERMISSION_TYPE.MANAGE && (
                        <div className="pageBodyRightPanel">{renderForm()}</div>
                    )}
            </div>

            <SideDrawer
                handleDrawerToggle={handleDrawerToggle}
                open={
                    open &&
                    permissions?.features?.[PERMISSION_FEATURE.REMINDER_SETTINGS] ===
                        PERMISSION_TYPE.MANAGE
                }
                drawerButton={true}
                drawerHeading="Add Reminder"
                mwebSideDrawerFooter>
                {renderForm()}
            </SideDrawer>
        </>
    )
}

const mapStateToProps = state => {
    return {
        loginData: state.loginDataReducer?.loginData,
        alert: state.alertReducer.alert
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addReminderAlertAction: payload =>
            dispatch(addReminderAlertAction(payload)),
        deleteReminderAlertAction: payload =>
            dispatch(deleteReminderAlertAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReminderSettings)
